import clsx, { type ClassValue } from 'clsx';

/**
 * Class composition. No tailwind-merge: this design uses a small, deliberate set
 * of utilities and components do not take a `className` that overrides their own
 * semantics, so there is nothing for a merger to resolve.
 */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
